import React from 'react'
import { Line } from 'react-chartjs-2'
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    Filler,
} from 'chart.js'
import { formatPeriodo, formatBs } from './utils'

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler)

export const TotalTrendChart = ({ serieData, title }) => {
    const granularidad = serieData?.granularidad || 'day'
    const serie = serieData?.serie ?? []
    const labels = serie.map((p) => formatPeriodo(p.periodo, granularidad))
    const data = serie.map((p) => p.total)
    const hayVentas = data.some((v) => v > 0)

    const misoptions = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: { mode: 'nearest', intersect: true },
        plugins: {
            legend: { display: false },
            tooltip: {
                mode: 'nearest',
                intersect: true,
                callbacks: { label: (ctx) => `Bs ${formatBs(ctx.raw)}` },
            },
        },
        scales: {
            y: {
                min: 0,
                ticks: { color: 'rgba(170,170,170)' },
                grid: { color: 'rgba(170,170,170,.2)' },
            },
            x: {
                ticks: { color: 'rgba(170,170,170)', autoSkip: true, maxRotation: 45 },
                grid: { display: false },
            },
        },
    }

    return (
        <div className='w-full min-w-0'>
            <div className='text-base dark:text-gray-300 text-gray-800 font-bold text-center mb-2'>{title}</div>
            {!hayVentas ? (
                <div className='text-sm text-gray-500 dark:text-gray-400 italic text-center py-8'>
                    Sin ventas en el rango seleccionado
                </div>
            ) : (
                <div className='w-full min-w-0 h-64 sm:h-80'>
                    <Line
                        data={{
                            labels,
                            datasets: [{
                                label: 'Ventas',
                                data,
                                borderColor: '#06d6a0',
                                backgroundColor: 'rgba(6, 214, 160, 0.25)',
                                fill: true,
                                tension: 0.3,
                                pointRadius: 3,
                                pointHoverRadius: 6,
                                pointHitRadius: 10,
                                borderWidth: 2,
                            }],
                        }}
                        options={misoptions}
                    />
                </div>
            )}
        </div>
    )
}
